import { ServerConnection } from '@paragon/data-connections';

import { UploadedFile } from '../files/UploadedFile';

const SealingServer = new ServerConnection('sealingServerApiUrl');

export async function pParseAlpineMetaFiles(ofFile?: UploadedFile): Promise<AlpineJobDescription> {
  const body: any = {};
  if (ofFile != null) body['ofFileContents'] = await ofFile.getContents();

  return SealingServer.post('alpine/parseFiles', body);
}

export interface AlpineJobDescription {
  jobName: string;
  designProgram: 'Alpine';
  designCode: string;

  /** A mapping from component names to internal alpine names */
  mappings: {
    [componentName: string]: string;
  };

  ofValues: {
    jobKey?: string;
    jobDescription?: string;
    version?: string;
    designCode?: string;

    windLoading?: string;

    topChordLiveLoad?: string;
    topChordDeadLoad?: string;
    bottomChordLiveLoad?: string;
    bottomChordDeadLoad?: string;
  };
}
